// 身份类型
export const IdentityTypeEnum = {
  Device: '设备',
  Service: '服务',
  User: '用户',
  Default: '客户端',
  Router: '边缘路由',
};

// 身份注册类型
export const IdentityEnrollEnum = {
  ott: '一次性令牌',
  ottca: '证书',
  // UPDB: 'updb',
};

// 策略类型
export const PolicyTypeEnum = {
  Dial: '起点',
  Bind: '终点',
  // UPDB: 'updb',
};

// @ts-ignore
export const PageSizeOptions = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

// 可视化接口刷新时长
export const VisualTime = 1000 * 60 * 5;

export interface SetStyleModel {
  width?: null | string;
  height?: null | string;
  fontSize?: null | string;
  color?: null | string;
  backgroundColor?: null | string;
  fontWeight?: null | string;
  fontStyle?: null | string;
  textDecoration?: null | string;
  textDecorationColor?: null | string;
  [property: string]: any;
}

export interface MediaModel {
  /**
   * 背景颜色
   */
  backGroundColor?: null | string;
  /**
   * 文字内容或文件路径
   */
  content?: null | string;
  detailId?: number | null;
  /**
   * 播放时长
   */
  duration?: number | null;
  /**
   * 字体 1-黑体 2-楷体 3-宋体 4-仿宋 5-隶书
   */
  font?: null | string;
  /**
   * 字体风格 0-常规 1-加粗 2-倾斜 4-下划线 8-中划线
   */
  fontStyle?: number | null;
  /**
   * 展示页面高度
   */
  height?: number | null;
  /**
   * 所属页面itemId
   */
  itemId?: null | string;
  /**
   * 所属节目id
   */
  parentId?: number | null;
  playCount?: number | null;
  /**
   * 节目id
   */
  playId?: number | null;
  /**
   * 字体颜色 1-红 2-绿 3-蓝 4-黄 5-紫 6-青 7-白 8- 黑 或RGB
   */
  textColor?: null | string;
  /**
   * 字体大小
   */
  textSize?: number | null;
  /**
   * 1文字 2图片3视频 4动图GIF
   */
  type?: null | string;
  /**
   * 文字类型定制样式
   */
  setStyle?: SetStyleModel;
  /**
   * 展示页面宽度
   */
  width?: number | null;
  /**
   * 横坐标
   */
  x?: number | null;
  /**
   * 纵坐标
   */
  y?: number | null;
  [property: string]: any;
}
